export const EUROPEAN_COUNTRIES = ["Russia", "Germany", "France", "Italy", "Spain", "Poland", "Ukraine", "Romania", "Netherlands", "Belgium", "Sweden", "Czech Republic (Czechia)", "Greece", "Portugal", "Hungary", "Belarus", "Austria", "Switzerland", "Serbia", "Bulgaria", "Denmark", "Slovakia", "Finland", "Norway", "Ireland", "Croatia", "Moldova", "Bosnia and Herzegovina", "Albania", "Lithuania", "Slovenia", "North Macedonia", "Latvia", "Estonia", "Luxembourg", "Montenegro", "Malta", "Iceland", "Andorra", "Liechtenstein", "Monaco", "San Marino", "Holy See"];

export const SHIPPING_SERVICES = {
  RM24: {
    name: "Royal Mail 24",
    price: 5.2,
    priceEurope: 8.99,
    priceGlobal: 30,
  },
  RM48: {
    name: "Royal Mail 48",
    price: 4.2,
    priceEurope: 15,
    priceGlobal: 30,
  },
  DPD: {
    name: "Royal Mail International Tracked",
    price: 30, // 10.99,
    priceEurope: 30, //14.99,
    priceGlobal: 30,
  },
  // RMInternational: {
  //   name: "Royal Mail International",
  //   price: 10.99,
  //   priceEurope: 15,
  //   priceGlobal: 22,
  // },
};

export const SAMPLE_DISCOUNT = 0.7;
export const DISCOUNT_RATE = 1 - SAMPLE_DISCOUNT;
export const TAX_ONLY_RATE = 0.2;

export const getShippingServicePrice = (shippingService: string, country?: string): number => {
  const service = SHIPPING_SERVICES[shippingService];
  if (!service) return 0;

  const isUK = country === 'United Kingdom';

  if (isUK) {
    return service.price || 0;
  } else {
    return service.priceGlobal || 0;
  }
};

type TShopifyShippingLine = { title?: string; code?: string };

export const mapShopifyShippingLineToService = (
  shippingLine?: TShopifyShippingLine | null,
): keyof typeof SHIPPING_SERVICES | null => {
  if (!shippingLine) return null;

  const combined = `${shippingLine.title || ''} ${shippingLine.code || ''}`.toLowerCase();
  if (!combined.trim()) return null;

  if (combined.includes('international')) {
    return 'DPD';
  }

  const isTracked24 = /\b24\b/.test(combined) && (combined.includes('tracked') || combined.includes('royal mail'));
  const isTracked48 = /\b48\b/.test(combined) && (combined.includes('tracked') || combined.includes('royal mail'));

  if (isTracked24 || combined.includes('royal mail 24') || combined.includes('rm24')) {
    return 'RM24';
  }
  if (isTracked48 || combined.includes('royal mail 48') || combined.includes('rm48')) {
    return 'RM48';
  }

  return null;
};

export const resolveOrderShippingService = (params: {
  shippingLine?: TShopifyShippingLine | null;
  country?: string;
  isITLuggage?: boolean;
  hasSuitcaseWithPersonalisedPanel?: boolean;
  storedShippingService?: string;
}): keyof typeof SHIPPING_SERVICES => {
  const isUK = params.country === 'United Kingdom';
  const isEurope = EUROPEAN_COUNTRIES.includes(params.country || '');
  const isGlobal = !isEurope && !isUK;
  const fromShopify = mapShopifyShippingLineToService(params.shippingLine);

  if (params.isITLuggage) {
    if (params.hasSuitcaseWithPersonalisedPanel) return 'DPD';
    if (params.storedShippingService && params.storedShippingService in SHIPPING_SERVICES) {
      return params.storedShippingService as keyof typeof SHIPPING_SERVICES;
    }
    return fromShopify || 'RM48';
  }

  if (isGlobal || isEurope) {
    return 'DPD';
  }

  if (params.storedShippingService && params.storedShippingService in SHIPPING_SERVICES) {
    return params.storedShippingService as keyof typeof SHIPPING_SERVICES;
  }

  if (fromShopify) {
    return fromShopify;
  }

  return 'RM48';
};
